import { getSubDomain } from "../utils/helperFns";

const AUTH_INFO = {
  clientId: process.env.NX_PUBLIC_CLIENT_ID,
  realm: process.env.NX_PUBLIC_REALM,
  grantType: process.env.NX_PUBLIC_GRANT_TYPE,
  redirectUri: process.env.NX_PUBLIC_REDIRECT_URI,
  publishUri: process.env.NX_PUBLIC_PUBLISH_URI,
  dspaceUri: process.env.NX_PUBLIC_DSPACE_URI,
  // The DAM community mapping is per-site: it is fetched from the site's Global
  // Config (authoring_getSitedetails) and cached in localStorage on every site
  // switch. These MUST be getters, not eagerly-evaluated values -- a plain
  // property is read once at module import (app boot) and would then serve the
  // previous site's community for the rest of the session on any switch that
  // does not happen to be followed by a full page reload.
  //
  // There is deliberately no process.env fallback: a site with no mapping must
  // fail closed rather than silently borrow another tenant's DAM community.
  get dspaceImagesUuid() {
    return typeof localStorage === "object" ? localStorage.getItem("imageUuid") || "" : "";
  },
  get dspaceVideosUuid() {
    return typeof localStorage === "object" ? localStorage.getItem("videoUuid") || "" : "";
  },
  get dspaceDocumentsUuid() {
    return typeof localStorage === "object" ? localStorage.getItem("documentUuid") || "" : "";
  },
  gcpUri: process.env.NX_PUBLIC_GCP_URL,
  gcpBucketName: process.env.NX_PUBLIC_BUCKET_NAME,
  deliveryEndPointGq: process.env.NX_PUBLIC_GRAPHQL_URI_PUBLISH,
};

// const LOGOUT_URL = `${process.env.NX_PUBLIC_API_URI}auth/logout?redirect_uri=${process.env.NX_PUBLIC_REDIRECT_URI}&client_id=${process.env.NX_PUBLIC_CLIENT_ID}&tenant_id=${process.env.NX_PUBLIC_REALM}`;
const AUTH_URL = `${process.env.NX_PUBLIC_KEYCLOAK_URI}/realms/${process.env.NX_PUBLIC_REALM}/protocol/openid-connect/auth?client_id=${process.env.NX_PUBLIC_CLIENT_ID}&response_type=code&redirect_uri=${process.env.NX_PUBLIC_REDIRECT_URI}&scope=openid`;
const REDIRECT_AUTH_URL = `${process.env.NX_PUBLIC_KEYCLOAK_URI}/realms/${process.env.NX_PUBLIC_REALM}/protocol/openid-connect/auth?client_id=${process.env.NX_PUBLIC_CLIENT_ID}&prompt=login&response_type=code&redirect_uri=${process.env.NX_PUBLIC_REDIRECT_URI}`;
// const NEW_LOGOUT_URL1 = `${process.env.NX_PUBLIC_KEYCLOAK_URI}/realms/${process.env.NX_PUBLIC_REALM}/protocol/openid-connect/logout?redirect_uri=${process.env.NX_PUBLIC_REDIRECT_URI}`;
const NEW_LOGOUT_URL = `${process.env.NX_PUBLIC_API_URI}auth/logout?client_id=${process.env.NX_PUBLIC_CLIENT_ID}&tenant_id=${process.env.NX_PUBLIC_REALM}&redirect_uri=${process.env.NX_PUBLIC_REDIRECT_URI}`;

const prelemBaseEndpointObj = (i18n) => {
  return {
    APIEndPoint: process.env.NX_PUBLIC_API_URI,
    PublishEndPoint: `${getSubDomain()}/`,
    device: "window",
    buttonBaseUrl: `${getSubDomain()}/`,
    language: i18n.language,
    deliveryEndPointGq: process.env.NX_PUBLIC_GRAPHQL_URI_PUBLISH,
    isRendering: false,
    captchaGoogleSiteKey: process.env.NX_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY,
    environment: process.env.NX_PUBLIC_ENVIRONMENT,
    enableCaptcha: process.env.NX_PUBLIC_ENABLE_RECAPTCHA,
    bucketName: process.env.NX_PUBLIC_BUCKET_NAME,
    bucketUrl: process.env.NX_PUBLIC_GCP_URL,
  };
};

export {
  AUTH_INFO,
  AUTH_URL,
  // LOGOUT_URL,
  NEW_LOGOUT_URL,
  prelemBaseEndpointObj,
  REDIRECT_AUTH_URL,
};
